import * as React from 'react';

function Home() {
    return <h2>Hello World</h2>;
  }

export default Home
